// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z6h8","title":"styles_title__rIiRK","cardWrapper":"styles_cardWrapper__r6F3d"};